/**
 * The page numbers to show: the first, the last and `radius` either side of the current one.
 *
 * @param current 1-based current page.
 * @param total Number of pages.
 * @param radius Pages shown on each side of the current one.
 * @returns Page numbers in order, with null where a run of pages is skipped.
 */
export function paginationWindow(current: number, total: number, radius = 2): (number | null)[] {
  const pages: (number | null)[] = [];
  for (let page = 1; page <= total; page++) {
    const shown = page === 1 || page === total || Math.abs(page - current) <= radius;
    if (shown) {
      pages.push(page);
    } else if (pages[pages.length - 1] !== null) {
      pages.push(null);
    }
  }
  return pages;
}
